import { useQuery } from '@tanstack/react-query';
import { productsApi } from '@/services/products';

export const useProducts = (params?: { category?: string }) => {
  return useQuery({
    queryKey: ['products', params?.category ?? 'all'],
    queryFn: () => productsApi.list({ category: params?.category }),
  });
};

export const useProduct = (id: string) => {
  return useQuery({
    queryKey: ['product', id],
    queryFn: () => productsApi.get(id),
    enabled: !!id,
  });
};
